var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "132px",
    height: "124px",
    viewBox: "0 0 132 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.21775 0.849 123.369 0.849 123.369 123.99965 0.21775 123.99965"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.7754 7.5156 0.7754 7.5156 8.2914 0 8.2914"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop-920-1024-copy-2",
    transform: "translate(-741.000000, -1174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(741.000000, 1173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    opacity: 0.0542224702
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(8.000000, 0.151000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.27,113.9474 L10.27,113.9474 C-3.133,100.5444 -3.133,78.6114 10.27,65.2074 L64.577,10.9014 C77.98,-2.5026 99.913,-2.5026 113.316,10.9014 C126.72,24.3044 126.72,46.2374 113.316,59.6404 L59.01,113.9474 C45.606,127.3504 23.673,127.3504 10.27,113.9474",
    id: "Fill-1",
    fill: "#0077FF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 74.151000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5156,4.5334 C7.5156,6.6094 5.8326,8.2914 3.7576,8.2914 C1.6826,8.2914 -0.0004,6.6094 -0.0004,4.5334 C-0.0004,2.4584 1.6826,0.7754 3.7576,0.7754 C5.8326,0.7754 7.5156,2.4584 7.5156,4.5334",
    id: "Fill-6",
    fill: "#0077FF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.726,103.1048 C122.726,104.1428 121.885,104.9838 120.847,104.9838 C119.809,104.9838 118.968,104.1428 118.968,103.1048 C118.968,102.0668 119.809,101.2258 120.847,101.2258 C121.885,101.2258 122.726,102.0668 122.726,103.1048",
    id: "Fill-9",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(106.000000, 23.151000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(51.000000, 5.151000)",
    stroke: "#0077FF"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.6621,
    y1: 0.8747,
    x2: 4.6621,
    y2: 9.1787,
    id: "Stroke-18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5102,
    y1: 5.027,
    x2: 8.8142,
    y2: 5.027,
    id: "Stroke-20"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M85.5307,26.2117 C85.5307,28.2877 83.8487,29.9697 81.7727,29.9697 C79.6977,29.9697 78.0157,28.2877 78.0157,26.2117 C78.0157,24.1367 79.6977,22.4537 81.7727,22.4537 C83.8487,22.4537 85.5307,24.1367 85.5307,26.2117 Z",
    id: "Stroke-4",
    stroke: "#0077FF",
    opacity: 0.148321243
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.7172,
    y1: 23.8626,
    x2: 106.7172,
    y2: 28.6426,
    id: "Stroke-11",
    stroke: "#0077FF",
    opacity: 0.148321243
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.6889,
    y1: 37.4524,
    x2: 115.9089,
    y2: 37.4524,
    id: "Stroke-13",
    stroke: "#0077FF",
    opacity: 0.148321243
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.5371,
    y1: 28.0144,
    x2: 113.0151,
    y2: 31.5374,
    id: "Stroke-15",
    stroke: "#0077FF",
    opacity: 0.148321243
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.062a7a5bbeb20ada6cb1f68f4d7a0b98.svg";
export { ForwardRef as ReactComponent };